"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNotNil = exports.guardOrNull = exports.guard = void 0;
var _ramda = require("ramda");
var isNotNil = exports.isNotNil = (0, _ramda.complement)(_ramda.isNil);

// (x -> y) -> x -> y
var guard = exports.guard = (0, _ramda.when)(isNotNil);

// (x -> y) -> x -> y
var guardOrNull = exports.guardOrNull = (0, _ramda.ifElse)(_ramda.isNil, (0, _ramda.always)(null));